/**
 * Issue #460 — the query string for `/stats/summary` and the three
 * `/matches/{seasons,competitions,teams}` option endpoints, shared by the
 * player's Statistics page and the coach's Career snapshot.
 *
 * Extracted from `pages/Statistics.jsx`'s local `toQuery` rather than
 * re-written beside it: the whole point of #460's snapshot half is that a
 * coach sees the numbers computed from THE SAME requests the player sees,
 * and two query builders is where "same" quietly stops being true. The
 * rules it encodes are the originals:
 *
 *  - "all" omits the param entirely (issues #55/#78), so untouched
 *    behaviour — today's exact unfiltered totals — is byte-identical on
 *    the wire, and the API's `blankToUndefined` leniency is never needed.
 *  - `player_id` is only ever present for a cross-player read (the coach's
 *    portal); a player reading their own stats sends none and the API
 *    scopes to the session (`resolveScope`, api/src/routes/authz.ts).
 */
export function toStatsQuery({ season = "all", competition = "all", team = "all", playerId } = {}) {
  const params = new URLSearchParams();
  if (playerId) params.set("player_id", playerId);
  if (season !== "all") params.set("season", season);
  if (competition !== "all") params.set("competition", competition);
  if (team !== "all") params.set("team", team);
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}
